import { log } from '../plugins/helpers'
import ENV from '../env'
import browserDetection from './../plugins/browserDetection'

export default {
  namespaced: true,

  state: {
    webcam_status: null, // active, not_allowed, not_available, unknown_error
    webcam_stream: null,
    webcam_interval: null,

    screen_recorder_status: null, // active, not_allowed, unknown_error
    screen_recorder_stream: null,
    screen_interval: null,

    audio_status: null,
    audio_stream: null,
    stop_audio_recording: false,

    now: Math.floor(Date.now() / 1000),
    user_picture: localStorage.getItem('user_picture') || null,
    user_picture_timestamp: localStorage.getItem('user_picture_timestamp'),
    user_picture_interval: null,

    pre_start_video: null,

    is_mobile_or_tablet: false
  },

  mutations: {
    SET_WEBCAM(state, { status, stream }) {
      log('webcam status:', status)
      log('webcam stream:', stream)
      state.webcam_status = status
      state.webcam_stream = stream
    },
    SET_AUDIO(state, { status, stream }) {
      log('audio status:', status)
      log('audio stream:', stream)
      state.audio_status = status
      state.audio_stream = stream
    },

    SET_SCREEN_RECORDER(state, { status, stream }) {
      log('screen recorder status:', status)
      log('screen recorder stream:', stream)
      state.screen_recorder_status = status
      state.screen_recorder_stream = stream
    },

    SET_WEBCAM_INTERVAL(state, id) {
      state.webcam_interval = id
    },

    SET_SCREEN_INTERVAL(state, id) {
      state.screen_interval = id
    },

    SET_USER_PICTURE(state, picture) {
      state.user_picture = picture
      state.user_picture_timestamp = Math.floor(Date.now() / 1000)
      if (picture !== null) {
        localStorage.setItem('user_picture', picture)
        localStorage.setItem('user_picture_timestamp', Math.floor(Date.now() / 1000))
      } else {
        localStorage.removeItem('user_picture')
        localStorage.removeItem('user_picture_timestamp')
      }
    },

    SET_USER_PICTURE_INTERVAL(state, interval) {
      state.user_picture_interval = interval
    },
    SET_NOW(state, data) {
      state.now = data
    },

    SET_IS_MOBILE_OR_TABLET(state, payload) {
      state.is_mobile_or_tablet = payload
    },

    STOP_AUDIO_RECORDING(state) {
      state.stop_audio_recording = true
    },

    SET_PRE_START_VIDEO(state, video) {
      state.pre_start_video = video
    },

    REMOVE_PRE_START_VIDEO(state) {
      state.pre_start_video = null
    }
  },

  getters: {
    initialInvigilateFulfilled(state, getters) {
      if (
        state.webcam_status === 'active' &&
        state.webcam_stream &&
        state.screen_recorder_status === 'active' &&
        state.screen_recorder_stream &&
        getters.userPictureFulfilled &&
        state.audio_status === 'active' &&
        state.audio_stream &&
        !state.is_mobile_or_tablet &&
        getters.browserFulfilled
      ) {
        return true
      }
      return false
    },
    examInvigilateFulfilled(state, getters) {
      if (
        state.webcam_status === 'active' &&
        state.webcam_stream &&
        state.screen_recorder_status === 'active' &&
        state.screen_recorder_stream &&
        state.audio_status === 'active' &&
        state.audio_stream &&
        !state.is_mobile_or_tablet &&
        getters.browserFulfilled
      ) {
        return true
      }
      return false
    },
    webcamAccessFulfilled(state) {
      if (state.webcam_status === 'active' && state.webcam_stream) {
        return true
      }
      return false
    },

    audioAccessFulfilled(state) {
      if (state.audio_status === 'active' && state.audio_stream) {
        return true
      }
      return false
    },
    screenRecorderFulfilled(state) {
      if (state.screen_recorder_status === 'active' && state.screen_recorder_stream) {
        return true
      }
      return false
    },
    userPictureFulfilled(state, getters) {
      if (getters.userPictureCountDown > 0 && state.user_picture) {
        return true
      }
      return false
    },

    userPictureCountDown(state) {
      if (state.user_picture) {
        return (
          ENV.invigilate.user_picture_expires_in - Math.floor((state.now - state.user_picture_timestamp) / 60)
        )
      }
      return -1
    },

    forceDesktopFulfilled(state) {
      return !state.is_mobile_or_tablet
    },
    browserFulfilled() {
      if (browserDetection.browser.name === 'Chrome' && browserDetection.browser.version > 69) {
        console.log('browserDetection.browser.version > 69')
        console.log(browserDetection.browser.version)
        console.log('browserDetection.browser.name')
        console.log(browserDetection.browser.name)
        return true
      }
      return false
    },

    preStartVideoFulfilled(state) {
      if (state.pre_start_video) {
        return true
      }
      return false
    }
  },

  actions: {
    setWebcam({ commit }, { stream, status }) {
      commit('SET_WEBCAM', { stream, status })
    },
    setAudio({ commit }, { stream, status }) {
      commit('SET_AUDIO', { stream, status })
    },
    setScreenRecorder({ commit }, { stream, status }) {
      commit('SET_SCREEN_RECORDER', { stream, status })
    },

    showInvigilateSetup({ commit }) {
      commit('SET_PAGE', 'invigilate_setup', { root: true })
    },

    setWebcamIntervalID({ commit }, id) {
      commit('SET_WEBCAM_INTERVAL', id)
    },
    setScreenIntervalID({ commit }, id) {
      commit('SET_SCREEN_INTERVAL', id)
    },

    clearWebcamInterval({ state }) {
      clearInterval(state.webcam_interval)
    },

    clearScreenInterval({ state }) {
      clearInterval(state.screen_interval)
    },

    stopAudioRecording({ commit }) {
      commit('STOP_AUDIO_RECORDING')
    },

    setUserPicture({ commit }, picture) {
      commit('SET_USER_PICTURE', picture)
    },

    // to make this vuex module reactive based on time
    // we refresh the state.now every 30 seconds
    // by doing this, all related getters (that are based on "now") are updated too
    startUserPicTimer({ state, commit, getters }) {
      console.log('USER PIC TIMER STARTED')
      commit('SET_NOW', Math.floor(Date.now() / 1000))
      clearInterval(state.user_picture_interval)
      let interval = setInterval(() => {
        commit('SET_NOW', Math.floor(Date.now() / 1000))
        if (getters.userPictureCountDown <= 0) {
          commit('SET_USER_PICTURE', null)
        }
      }, 30000)

      commit('SET_USER_PICTURE_INTERVAL', interval)
    },

    setIsMobileOrTablet({ commit }, payload) {
      commit('SET_IS_MOBILE_OR_TABLET', payload)
    },

    savePreStartVideo({ commit }, video) {
      commit('SET_PRE_START_VIDEO', video)
    },
    removePreStartVideo({ commit }) {
      commit('REMOVE_PRE_START_VIDEO')
    }
  }
}
